import { getAxiosInstanceWithoutErrorChecking } from 'app/config/api';

export const resolveGtin = actionParams =>
  getAxiosInstanceWithoutErrorChecking().post('actions', {
    payload: actionParams,
    action: 'v1.dabas.resolveGtin',
  });
